module.exports = __webpack_public_path__ + "b74e3d6acc68ef8b5eb4aee6e21561a7.svg";